import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "chevron-right",
  "use": "chevron-right-usage",
  "viewBox": "0 0 500 500",
  "content": "<symbol viewBox=\"0 0 500 500\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"chevron-right\">\n<path d=\"M135.022 48.5438C129.664 43.1627 129.659 34.4326 135.01 29.0446C140.362 23.6567 149.044 23.6511 154.403 29.0323L364.66 240.181C370.023 245.565 370.024 254.303 364.663 259.689L154.405 470.965C149.049 476.348 140.366 476.345 135.013 470.958C129.66 465.572 129.663 456.842 135.02 451.459L335.569 249.939L135.022 48.5438Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol